module.exports = __webpack_public_path__ + "static/mobile-hero-15f62988a0c614a97ff9579de085f0f8.jpg";